import React, { useEffect, useState } from 'react';
import IncomeField from './IncomeField';


const AddIncome = () => {
     return (
        <div className='mx-auto p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add An Income</h1>
            <IncomeField></IncomeField>
        </div>
    );
};

export default AddIncome;